import { render, staticRenderFns } from "./ShipmentDeductionAndIncrease.vue?vue&type=template&id=6205fc64"
import script from "./ShipmentDeductionAndIncrease.vue?vue&type=script&lang=js"
export * from "./ShipmentDeductionAndIncrease.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDeductionAndIncrease.vue?vue&type=style&index=0&id=6205fc64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports